import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=6eb49744&"
import script from "./ModalWindow.vue?vue&type=script&lang=js&"
export * from "./ModalWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports